import { legacyRedirect } from './-components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/tasks')({
  beforeLoad: legacyRedirect('/workspaces/:workspaceId/health?tab=data&scrollTo=tasks'),
});
